/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BuyerEmailItemDTO interface.
 */
export function instanceOfBuyerEmailItemDTO(value) {
    if (!('orderId' in value) || value['orderId'] === undefined)
        return false;
    return true;
}
export function BuyerEmailItemDTOFromJSON(json) {
    return BuyerEmailItemDTOFromJSONTyped(json, false);
}
export function BuyerEmailItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderId': json['orderId'],
        'buyerEmail': json['buyerEmail'] == null ? undefined : json['buyerEmail'],
    };
}
export function BuyerEmailItemDTOToJSON(json) {
    return BuyerEmailItemDTOToJSONTyped(json, false);
}
export function BuyerEmailItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderId': value['orderId'],
        'buyerEmail': value['buyerEmail'],
    };
}
